type Resolver = () => void;

/**
 * Waiters for one in-flight `open()` or `close()` transition.
 */
interface ResolverQueue {
  current: Resolver[];
}

/**
 * Resolves every waiter currently queued, then clears the queue.
 */
export function flushResolvers(queue: ResolverQueue) {
  const resolvers = queue.current;

  if (resolvers.length === 0) {
    return;
  }

  queue.current = [];
  resolvers.forEach((resolve) => resolve());
}

/**
 * Returns a promise that resolves the next time `flushResolvers` drains this queue.
 */
export function waitForResolvers(queue: ResolverQueue) {
  return new Promise<void>((resolve) => {
    queue.current.push(resolve);
  });
}
